enum Status {
  COMPLETED = 'completed',
  NEED_SIGNING = 'need_signing',
  ON_PROCESSING = 'on_processing',
  ON_SIGNING = 'on_signing',
  ON_GOING = 'on_going',
  PROCESSING_FAILED = 'processing_failed',
  REJECTED = 'rejected',
  REQUEST_CANCELLED = 'request_cancelled',
  SIGNING_CANCELLED = 'signing_cancelled',
  WAIT_FOR_SIGNING = 'wait_for_signing',
  SCHEDULE_READY = 'schedule_ready',
  SCHEDULE_START_FAILED = 'schedule_start_failed',
  SCHEDULE_CANCELED = 'schedule_canceled',
}

export default Status;
